// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__2s6vz","icon":"SortAdornment_icon__30yEL","up":"SortAdornment_up__3w_hD","down":"SortAdornment_down__3jNRC","active":"SortAdornment_active__1eM4Z"};